// Vendor
import classnames from 'classnames';
import * as React from 'react';

// Internal
import { Header } from '@src/components/Header/Header';
import { Navigation } from '@src/components/Navigation/Navigation';

// Styles
import styles from './styles.module.css';

const BaseLayout: React.FC = (props) => {
  const { children } = props;

  // Hooks
  const [navOpen, setNavOpen] = React.useState(false);

  // Styles
  const classesOverlay = classnames(styles.overlay, {
    [styles.hide]: !navOpen
  });

  // Handlers
  const onMenuClick = () => {
    setNavOpen(!navOpen);
  };

  const onOverlayClick = () => {
    setNavOpen(false);
  };

  return (
    <div className="tup-root">
      <Header onMenuClick={onMenuClick} />
      <Navigation isOpen={navOpen} onLinkClick={onOverlayClick} />
      <div className="pt-12 lg:pt-0">
        <main className="tup-main">{children}</main>
        {/* TODO: FIXME: add footer */}
        <footer></footer>
      </div>
      <div className={classesOverlay} onClick={onOverlayClick} />
    </div>
  );
};

export { BaseLayout };
